import { ED_CONTEXT_MENU } from '../../ed-context-menu.plugin';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ED_CONTEXT_MENU_DIRECTIONS } from '../../ed-context-menu.values';
import { EdContextMenuNavModel } from '../../models/ed-context-menu-nav.model';

@Component({
  name: 'ed-context-menu-nav'
})
export default class EdContextMenuNav extends Vue {

  @Prop() readonly options: EdContextMenuNavModel[];
  @Prop() readonly orientation: any;
  @Prop() readonly position: any;
  @Prop() readonly spaceTop: number;

  public nav: EdContextMenuNavModel[] = [];
  public submenuStyle: any = null;
  public heightItem: number = 42;
  public maxHeight: number = 450;
  public submenuOrientation: string = '';

  get top() {
    return this.spaceTop ? this.spaceTop : 0;
  }
  
  get containerClass(): string[] {
    return this.orientation ? ED_CONTEXT_MENU_DIRECTIONS[this.orientation].cssClass : '';
  }

  get containerStyle() {
    return { top: `${(this.position.y)}px` }
  }

  get navStyle(): any {
    let top = 0;
    if(this.$el) top = Number(this.$el.parentElement.style.top.replace('px', ''));
    let positionY = (top + this.position.y);
    let menuHeight = this.heightItem * this.nav.length;
    let height = menuHeight > this.maxHeight ? this.maxHeight : menuHeight;
    let available = (window.innerHeight - positionY) - 2*this.heightItem;
    return {
      height: `${available > height ? height : available}px`,
      overflowY: available > height ? 'auto' : 'scroll'
    }
  }

  get submenu() {
    return this.nav.filter(n => n.submenu ? true : false);
  }

  async selectOption(e: MouseEvent, item: EdContextMenuNavModel) {
    if(item.disabled) {
      return;
    }
    if(!item.submenu) {
      this.$EdContextMenu.$emit(ED_CONTEXT_MENU.EVENTS.CLOSE_CONTEXT_MENU, item);
    } else {
      this.setSubMenuPosition(item, e.clientY);
      this.nav.forEach(n => {
        n.opened = n.id == item.id ? !n.opened : false;
        n.selected = n.id == item.id ? !n.selected : false;
        if(!n.opened && n.submenu) {
          if(document.getElementById(`SUB${item.id}`)) {
            document.getElementById(`SUB${item.id}`).style.opacity = '0';
          }
          this.closeChildren(n.submenu);
        }
      });
      if(item.opened) this.setSubMenu(item);
    }
  }

  closeChildren(nav: EdContextMenuNavModel[]) {
    nav.forEach((item) => {
      if(item.submenu) {
        item.opened = false;
        item.selected = false;
        item.style = {};
        this.closeChildren(item.submenu);
      }
    });
  }

  setSubMenuPosition(item: EdContextMenuNavModel, currentY: number) {
    let i = this.nav.indexOf(item);
    let menu: any = this.$el;
    let menuWidth = (menu.clientWidth + 10);
    let spaceTop = (this.top == 0 || !this.top) ? 46 : this.top;
    let x = this.position.x + menuWidth + 20;
    let y = (currentY - spaceTop - this.position.y);
    this.nav[i].submenuposition = { x, y };
  }

  setSubMenu(item: EdContextMenuNavModel) {
    let i = this.nav.indexOf(item);
    let submenu = this.nav[i];
    let id = `SUB${submenu.id}`;
    let menu: any = this.$el
    let maxWidth = window.innerWidth;
    let menuWidth = (menu.clientWidth + 10);
    setTimeout(() => {
      let nMenuWidth = document.getElementById(id).clientWidth;
      let margin = `${menuWidth}px`;
      let subMenuPosition = 0;
      switch(this.orientation) {
        case ED_CONTEXT_MENU_DIRECTIONS.TOP_TO_BOTTOM.code:
        case ED_CONTEXT_MENU_DIRECTIONS.LEFT_TO_RIGHT.code:
          subMenuPosition = ((maxWidth + 90) - (this.position.x + (menuWidth + nMenuWidth) + 20));
          if(subMenuPosition < 0) {
            this.submenuOrientation = ED_CONTEXT_MENU_DIRECTIONS.RIGH_TO_LEFT.code;
            this.nav[i].submenuposition.x = this.nav[i].submenuposition.x - (nMenuWidth + nMenuWidth + 20);
            document.getElementById(id).style.right = margin;
          } else {
            this.submenuOrientation = ED_CONTEXT_MENU_DIRECTIONS.LEFT_TO_RIGHT.code;
            document.getElementById(id).style.left = margin;
          }
        break;
        case ED_CONTEXT_MENU_DIRECTIONS.RIGH_TO_LEFT.code:
          subMenuPosition = this.position.x - (nMenuWidth + 100);
          if(subMenuPosition < 0) {
            this.submenuOrientation = ED_CONTEXT_MENU_DIRECTIONS.LEFT_TO_RIGHT.code;
            document.getElementById(id).style.left = margin;
          } else {
            this.submenuOrientation = ED_CONTEXT_MENU_DIRECTIONS.RIGH_TO_LEFT.code;
            document.getElementById(id).style.right = margin;
          }
        break;
      }
      document.getElementById(id).style.zIndex = String(submenu.zIndex);
      document.getElementById(id).style.opacity = '1';
    }, 50);
  }

  getSpaceTop() {
    let spaceTop = this.top ? this.top : 46;
    return spaceTop + this.position.y;
  }

  created() {
    setTimeout(() => {
      this.nav = this.options;
    }, 100);
  }

}
